export default __webpack_public_path__ + "static/media/gaeko_active.c63bec67.mp4";